import { Injectable } from '@angular/core';
import { environment } from '@tech-environments/environment';
import { SessionService } from './session.service';
import { AppConfig } from '@tech-utils/app-config.service';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { CommonService } from './common.service';
import { BehaviorSubject, Subject, throwError } from 'rxjs';

import {
  InitcontributionService as sdkService,
  PortfolioInterface,
  FeeInterface,
  SimulationObjInterface,
  FinancialPlanRefdataInterface,
  EvalGoalInterface,
} from '@techrules/portallib';

@Injectable({
  providedIn: 'root',
})
export class InitcontributionService {
  private http: HttpClient;
  public profileAnalysisSource = new BehaviorSubject<PortfolioInterface>(
    {} as any
  );
  public profileAnalysis$ = this.profileAnalysisSource.asObservable();
  public simulationObjSource = new BehaviorSubject<SimulationObjInterface>(
    {} as any
  );
  public simulationObj$ = this.simulationObjSource.asObservable();
  public fpReferenceDataSource =
    new BehaviorSubject<FinancialPlanRefdataInterface>({} as any);
  public fpReferenceData$ = this.fpReferenceDataSource.asObservable();
  public evalGoalObjSource = new BehaviorSubject<EvalGoalInterface>({} as any);
  public evalGoalObj$ = this.evalGoalObjSource.asObservable();
  public agreeRiskWarningSource = new BehaviorSubject<boolean>(false);
  public agreeRiskWarning$ = this.agreeRiskWarningSource.asObservable();
  public errorMinimunSource = new BehaviorSubject<any>(false);
  public errorMinimun$ = this.errorMinimunSource.asObservable();
  public currencyContributionSource = new BehaviorSubject<string>('');
  public currencyContribution$ = this.currencyContributionSource.asObservable();

  constructor(
    private session: SessionService,
    private httpBackend: HttpBackend,
    private commonService: CommonService,
    private sdkSvc: sdkService
  ) {}

  public getEvalGoal(obj: SimulationObjInterface) {
    return this.sdkSvc.getEvalGoal(obj).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.loading$.next(false);
        this.commonService.errorManager('getEval', err);
        return throwError(err);
      })
    );
  }

  public getProfileAnalysis() {
    let goalAmount = this.simulationObjSource.getValue().GoalAmount;
    let profileId = this.simulationObjSource.getValue().ProfileId.toString();
    return this.sdkSvc.getProfileAnalysis(goalAmount, profileId).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.loading$.next(false);
        this.commonService.errorManager('profile_analysis', err);
        return throwError(err);
      })
    );
  }

  public getFinancialPlanRefData() {
    return this.sdkSvc.getFinancialPlanRefData().pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.loading$.next(false);
        this.commonService.errorManager('get_eval_refdata', err);
        return throwError(err);
      })
    );
  }

  public getFees() {
    let profileId = this.simulationObjSource.getValue().ProfileId.toString();
    return this.sdkSvc.getFees(profileId).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.loading$.next(false);
        this.commonService.errorManager('apirest_fees', err);
        return throwError(err);
      })
    );
  }

  public saveGoal(goal: SimulationObjInterface) {
    return this.sdkSvc.saveGoal(goal).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.loading$.next(false);
        this.commonService.errorManager('saveGoal', err);
        return throwError(err);
      })
    );
  }

  public saveGoalPortfolio(goalId: string) {
    return this.sdkSvc
      .saveGoalPortfolio(goalId, localStorage.getItem('portfolioCode'))
      .pipe(
        map((res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        }),
        catchError((err) => {
          this.commonService.loading$.next(false);
          this.commonService.errorManager('apirest_goal_portfolio', err);
          return throwError(err);
        })
      );
  }

  public funding(issuingBank: string, investCurrency: string) {
    // const headers = environment.httpHeader(this.session);
    let bodyRequest = {
      BankName: issuingBank,
      Amount: this.simulationObjSource.getValue().InitialContributionAmount,
      Currency: investCurrency,
      Exoneration: this.agreeRiskWarningSource.getValue(),
      FundTransfers: [],
      ModelPortfolioCode:
        this.evalGoalObjSource.getValue().model_portfolio_code,
    };
    return this.sdkSvc
      .funding(bodyRequest, localStorage.getItem('portfolioCode'))
      .pipe(
        map((res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        }),
        catchError((err) => {
          this.commonService.loading$.next(false);
          this.commonService.errorManager('apirest_funding', err);
          return throwError(err);
        })
      );
  }

  public getCurrencies() {
    return this.sdkSvc.getCurrencies().pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.loading$.next(false);
        this.commonService.errorManager('getCurrencies', err);
        return throwError(err);
      })
    );
  }

  public getModelPortfolio() {
    let modelPortfolioCode =
      this.evalGoalObjSource.getValue().model_portfolio_code;
    return this.sdkSvc.getModelPortfolio(modelPortfolioCode).pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.loading$.next(false);
        this.commonService.errorManager('apirest_minimun', err);
        return throwError(err);
      })
    );
  }
}
